import * as React from 'react';

import { Inline } from '~shared/components/Inline';
import { Stack } from '~shared/components/Stack';
import { ReactNodeNoStrings } from '~shared/types';

import { Dialog, DialogProps } from './Dialog';
import { DialogTitle } from './DialogTitle';

interface Props extends Omit<DialogProps, 'children' | 'padding'> {
  children: React.ReactNode;
  actions: ReactNodeNoStrings[];
}

/**
 * Abstract component for common confirmation dialog styles.
 */
export function DialogConfirmation({ children, actions, ...props }: Props) {
  return (
    <Dialog padding="confirmation" {...props}>
      {(headerProps) => (
        <div className="text-center">
          <Stack space="4">
            <h3 className="m-0">
              <DialogTitle
                ref={headerProps.headingRef}
                style={{ paddingRight: 0 }}
              >
                {headerProps.title}
              </DialogTitle>
            </h3>
            <div className="text-base text-blue-900 leading-8">{children}</div>
          </Stack>
          <div className="pt-8">
            <Inline align="center">{actions.map((action) => action)}</Inline>
          </div>
        </div>
      )}
    </Dialog>
  );
}
